import React from "react";
import { Check } from "lucide-react";

const SYM = { GBP: "£", USD: "$", EUR: "€" };
const LOC = { GBP: "en-GB", USD: "en-US", EUR: "en-IE" };
export const money = (n, cur = "GBP") => (SYM[cur] || "£") + Number(n || 0).toLocaleString(LOC[cur] || "en-GB");
export const gbp = (n) => money(n, "GBP"); // back-compat

export function OfferBadge({ discount }) {
  if (!discount) return null;
  return (
    <span className="inline-block bg-pgt-green text-black text-[10px] font-display font-bold uppercase tracking-wider px-2 py-0.5 rounded-sm" data-testid="offer-badge">
      {Math.round(discount)}% OFF
    </span>
  );
}

export function OfferPrice({ rrp, price, discount, currency = "GBP", size = "lg" }) {
  const cls = size === "sm" ? "text-2xl" : "text-3xl";
  return (
    <div className="flex items-baseline gap-2 flex-wrap">
      {discount ? <span className="text-white/40 line-through text-sm" data-testid="offer-rrp">{money(rrp, currency)}</span> : null}
      <span className={`font-display font-extrabold ${cls} text-pgt-green`} data-testid="offer-sale">{money(price, currency)}</span>
      <OfferBadge discount={discount} />
    </div>
  );
}

export function YouSave({ amount, currency = "GBP" }) {
  if (!amount || amount <= 0) return null;
  return (
    <div className="text-pgt-green text-xs font-display font-bold uppercase tracking-wider" data-testid="you-save">
      You save {money(amount, currency)}
    </div>
  );
}

export function OfferCards({ price, turnaround, speed, onSelect, expressAllowed }) {
  const o = price.options || {};
  const cur = price.currency || "GBP";
  const tr = turnaround || {};
  const stdOn = tr.standard_enabled !== false;
  const expOn = tr.express_enabled !== false && expressAllowed !== false;
  let items = [["standard", "Standard", o.standard, tr.standard_turnaround], ["express", "Express", o.express, tr.express_turnaround]];
  items = items.filter(([k]) => (k === "standard" ? stdOn : expOn));
  const selectable = typeof onSelect === "function";
  return (
    <div className={`grid ${items.length > 1 ? "grid-cols-2" : "grid-cols-1"} gap-3`} data-testid="offer-cards">
      {items.map(([k, label, opt, time]) => opt ? (
        <button type="button" key={k} disabled={!selectable} onClick={() => selectable && onSelect(k)}
          className={`text-left border rounded-sm p-3 bg-pgt-bg transition-colors ${selectable ? "cursor-pointer" : "cursor-default"} ${selectable && speed === k ? "border-pgt-green ring-1 ring-pgt-green" : "border-white/15 hover:border-white/30"}`}
          data-testid={`offer-${k}`}>
          <div className="font-display font-bold uppercase text-white text-sm">{label}</div>
          <div className="text-white/45 text-[11px] mb-2">{time || opt.delivery_time}</div>
          <OfferPrice rrp={opt.rrp} price={opt.price} discount={price.discount_pct} currency={cur} size="sm" />
          <YouSave amount={opt.you_save} currency={cur} />
        </button>
      ) : null)}
    </div>
  );
}

export function AllInNote({ note, offerLabel }) {
  return (
    <div className="mt-2 text-center">
      {offerLabel ? <div className="text-pgt-green font-display font-bold uppercase text-xs tracking-wider">{offerLabel}</div> : null}
      {note ? <div className="text-white/50 text-[11px]">{note}</div> : null}
    </div>
  );
}

export function IncludedList({ items }) {
  if (!items || !items.length) return null;
  return (
    <ul className="mt-4 space-y-1.5" data-testid="included-list">
      {items.map((t, i) => (
        <li key={i} className="flex items-start gap-2 text-white/70 text-sm">
          <Check size={15} className="text-pgt-green mt-0.5 shrink-0" />{t}
        </li>
      ))}
    </ul>
  );
}
